{
  "PHONE_CTRLS": {
    "EXTENSION_BANNER": {
      "TEXT": "Chrome extension not installed.",
      "CTA": "Install extension"
    },
    "STATUS": {
      "OFFLINE": "Phone offline",
      "IN_OTHER_TAB": "Phone connected in another tab",
      "CONNECTING": "Connecting...",
      "DISCONNECTING": "Disconnecting...",
      "ONLINE": "Phone online",
      "DIALING": "Dialing",
      "TRANSFERRING": "Transferring...",
      "CONSULTING": "Talking to agent",
      "CALLER_ON_HOLD": "Caller is on hold",
      "BUSY": "Busy",
      "DND": "DND",
      "UNAVAILABLE": "Unavailable",
      "REJECTED": "Call rejected",
      "CALL_FAILED": "Call failed"
    },
    "QUEUES": {
      "MORE": "More queues"
    },
    "TABS": {
      "PHONE": "Phone",
      "SMS": "SMS",
      "HISTORY": "History"
    },
    "HISTORY": {
      "OPEN": "Open",
      "RECENT": "Recent",
      "MISSED": "Missed",
      "LOADING": "Loading calls...",
      "EMPTY": "No calls here",
      "ERROR": "Could not load the calls",
      "CALL": "Call back",
      "CALL_STATUS": {
        "BUTTON": "Set call status",
        "TITLE": "Call status",
        "SEARCH_PLACEHOLDER": "Search statuses...",
        "LOADING": "Loading statuses...",
        "NO_OPTIONS": "No call statuses are configured",
        "NO_MATCH": "No status matches",
        "OPTIONS_ERROR": "Could not load the statuses",
        "RETRY": "Try again",
        "CONFIRM_QUESTION": "Set “{status}” and resolve the conversation?",
        "CONFIRM": "Confirm",
        "BACK": "Back",
        "CANCEL": "Cancel",
        "SAVING": "Saving...",
        "SAVE_ERROR": "Could not save the status",
        "RESOLVE_ERROR": "Status saved, but the conversation could not be resolved"
      }
    },
    "SMS": {
      "NUMBER_PLACEHOLDER": "Phone number, e.g. +421903000000",
      "BODY_PLACEHOLDER": "Type your message...",
      "SEGMENTS": "({segments} SMS)",
      "SEND": "Send SMS",
      "SENDING": "Sending...",
      "SENT": "SMS sent",
      "LOADING": "Loading SMS inboxes...",
      "NO_INBOX": "This account has no SMS inbox, so SMS cannot be sent.",
      "INVALID_NUMBER": "Enter the number in international format, including the leading +.",
      "ERROR": "The SMS could not be sent. Please try again."
    },
    "ACTIONS": {
      "CONNECT": "Connect",
      "GO_TO_TAB": "Go to that tab",
      "DISCONNECT": "Disconnect",
      "ANSWER": "Answer",
      "HANGUP": "Hangup",
      "HOLD": "Hold",
      "MUTE": "Mute microphone",
      "SILENCE": "Silence audio",
      "TRANSFER": "Transfer",
      "COMPLETE_TRANSFER": "Complete transfer",
      "RETURN_TO_CALLER": "Return to caller",
      "CANCEL_TRANSFER": "Cancel transfer",
      "DIALPAD": "Show dialpad",
      "OPEN_CONVERSATION": "Open conversation"
    },
    "NOTIFICATIONS": {
      "INCOMING_CALL": "Incoming Call",
      "INCOMING_CALL_FROM": "Incoming call from {name} ({number})",
      "INCOMING_CALL_FROM_NUMBER": "Incoming call from {number}",
      "ANSWER": "Answer",
      "DECLINE": "Decline"
    },
    "TRANSFER": {
      "TITLE": "Transfer Call",
      "PLACEHOLDER": "Enter transfer target number...",
      "SEARCH_PLACEHOLDER": "Search agents...",
      "TARGET_PLACEHOLDER": "Selected transfer target",
      "CONFIRM": "Transfer",
      "MODE_DIRECT": "Transfer now",
      "MODE_CONSULT": "Call agent first",
      "CANCEL": "Cancel"
    },
    "QUEUE_BREAK": {
      "CONFIRM_BREAK": "Are you sure you want to go on break for all queues?",
      "CONFIRM_READY": "Are you sure you want to go back to ready status for all queues?",
      "CONFIRM_BREAK_QUEUE": "Are you sure you want to log out of the {queue} queue?",
      "CONFIRM_READY_QUEUE": "Are you sure you want to log in to the {queue} queue?",
      "LOGIN_TO_QUEUE": "Log in",
      "LOGOUT_FROM_QUEUE": "Log out",
      "LOGIN_TO_ALL_QUEUES": "Log in to all queues",
      "LOGOUT_FROM_ALL_QUEUES": "Log out of all queues",
      "OPTION_LOGOUT": "Log out",
      "OPTION_BREAK": "Break",
      "OPTION_LUNCH": "Lunch",
      "OPTION_AWAY": "Away",
      "OPTION_DO_NOT_DISTURB": "Do not disturb",
      "OPTION_BUSINESS_TRIP": "Business trip",
      "CONFIRM": "Confirm",
      "CANCEL": "Cancel"
    },
    "CONNECTION_ERROR": {
      "TITLE": "No connection to the phone system",
      "MESSAGE": "Your internet connection appears to be down. Please check it and try again.",
      "CREDENTIALS_TITLE": "The phone system rejected your credentials",
      "CREDENTIALS_MESSAGE": "The phone system refused the user name or password saved in your profile. Check them in Profile settings, or ask your administrator.",
      "CONFIGURATION_TITLE": "Phone settings are not valid",
      "CONFIGURATION_MESSAGE": "The SIP user name or the server address is not in a valid format, so the phone cannot connect. Fix it in Profile settings.",
      "NETWORK_SHORT": "Connection failed",
      "CREDENTIALS_SHORT": "Credentials rejected",
      "CONFIGURATION_SHORT": "Invalid phone settings",
      "RETRY": "Try again",
      "DISMISS": "Cancel"
    },
    "CONNECTION_QUALITY": "Connection quality",
    "CONNECTION_QUALITY_EXCELLENT": "Excellent",
    "CONNECTION_QUALITY_GOOD": "Good",
    "CONNECTION_QUALITY_FAIR": "Fair",
    "CONNECTION_QUALITY_POOR": "Poor",
    "CONNECTION_QUALITY_DISCONNECTED": "Disconnected"
  },
  "DIAL_REDIRECT": {
    "DIALING": "Dialing {number}… You can close this tab.",
    "NO_NUMBER": "No number provided. Use ?number=+420..."
  },
  "PHONE_DIAL": {
    "PLACEHOLDER": "Enter phone number...",
    "ACTIONS": {
      "DIAL": "Dial number",
      "DIAL_FROM": "Choose the number to call from"
    },
    "DIAL_FROM": {
      "TITLE": "Call from an inbox number"
    },
    "VALIDATION": {
      "REQUIRED": "Phone number is required",
      "INVALID_FORMAT": "Invalid phone number format"
    }
  },
  "PHONE_AUDIO": {
    "TITLE": "Audio Settings & Testing",
    "SELECT_DEVICE": "Select device...",
    "SYSTEM_DEFAULT": "System default",
    "SAVED": "Saved",
    "DISCONNECTED_SUFFIX": "not connected",
    "DEVICE_DISCONNECTED": "The selected device is not connected. Calls use the system default until it is back.",
    "MICROPHONE": {
      "TITLE": "Microphone",
      "START_TEST": "Test Microphone",
      "STOP_TEST": "Stop Test",
      "LEVEL": "Level:",
      "VERDICT": {
        "LISTENING": "Say something into the microphone…",
        "SILENT": "You can't be heard. Check that the microphone is on and the right one is selected.",
        "LOW": "You can be heard only quietly. Choose a different microphone or adjust the input volume in your system settings.",
        "GOOD": "Good sound — you can be heard well."
      }
    },
    "SPEAKER": {
      "TITLE": "Speaker",
      "TEST": "Test Speaker",
      "TESTING": "Testing...",
      "VOLUME": "Volume:",
      "USING_DEFAULT": "Selected output is unavailable — played on the system default."
    },
    "DONE": "Done",
    "ERRORS": {
      "MICROPHONE_ACCESS": "Error accessing microphone. Please check permissions.",
      "MICROPHONE_PERMISSION_DENIED": "Microphone access is blocked. Allow it in your browser's site settings to use the phone.",
      "MICROPHONE_SILENT": "Your microphone is not picking up any sound. Check your audio settings.",
      "EXTENSION_REQUIRED": "Phone extension not detected. Please install or enable it to use the microphone.",
      "SPEAKER_TEST": "Error testing speaker output."
    }
  },
  "PHONE_STATUS": {
    "OFFLINE": "Offline",
    "ONLINE": "Online",
    "BUSY": "Busy"
  },
  "QUEUE_STATUS": {
    "READY": "Ready",
    "NOT_READY": "Not accepting calls",
    "WRAP_UP": "Wrap Up",
    "BREAK": "Break",
    "LUNCH": "Lunch",
    "AWAY": "Away",
    "DO_NOT_DISTURB": "Do not disturb",
    "BUSINESS_TRIP": "Business trip",
    "OTHER_CALL": "Other Call",
    "QUEUE_CALL": "Queue Call",
    "OFFLINE": "Offline",
    "ONLINE": "Online",
    "NO_ACCESS": "No phone",
    "PARTIALLY_READY": "Partially ready",
    "MIXED": "Mixed",
    "CHAT_ONLINE": "Online (chat)",
    "CHAT_BUSY": "Busy (chat)",
    "CHAT_OFFLINE": "Offline (chat)"
  }
}
